export default "__VITE_ASSET__DdeDB$b7__"